// extracted by mini-css-extract-plugin
module.exports = {"list":"HeaderNavMenu_list__1HciI","item":"HeaderNavMenu_item__1Z5Bf"};